import { Layout } from "../components/Layout";
import { WholesaleEnquirySection } from "../components/WholesaleEnquirySection";
import { Handshake, BadgePercent, Boxes, Headset } from "lucide-react";

const PERKS = [
  { icon: BadgePercent, title: "Factory-Direct Rates", text: "Transparent wholesale pricing with volume-based slabs." },
  { icon: Boxes, title: "Bulk Availability", text: "Large-quantity stock across grass, mats, carpets & felt." },
  { icon: Handshake, title: "Dealer Partnerships", text: "Long-term supply arrangements for dealers & distributors." },
  { icon: Headset, title: "Priority Support", text: "A dedicated point of contact for your wholesale orders." },
];

export default function WholesalePage() {
  return (
    <Layout>
      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">For Trade & Projects</span>
        <h1 className="mt-2 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-[#0B1B3D] sm:text-5xl">
          Wholesale & Bulk Supply
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-slate-600">
          Built for dealers, distributors, retailers, contractors and commercial projects. Tell us your
          requirement and get factory-direct wholesale pricing — no cart, no checkout.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PERKS.map((p) => (
            <div key={p.title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0B1B3D] text-[#10B981]"><p.icon className="h-6 w-6" /></span>
              <h3 className="mt-4 font-display text-lg font-semibold text-[#0B1B3D]">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.text}</p>
            </div>
          ))}
        </div>
      </section>
      <WholesaleEnquirySection />
    </Layout>
  );
}
